import { Container, Row } from "reactstrap";
import LoginWithValidationContainer from "../../Componant/Authentication/LoginWithValidation/index.tsx";

const LoginWithValidation = () => {
  return (
    <Container fluid>
      <Row>
        <LoginWithValidationContainer />
      </Row>
    </Container>
  );
};

export default LoginWithValidation;
